import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const SellerPan = createAsyncThunk(
  "sellerPan/SellerPan",
  async (data, thunkAPI) => {
    const formData = new FormData();
    const SellerId = localStorage.getItem("SellerloginData");
    const file = await fetch(data.panImage)
      .then((res) => res.blob())
      .then((blob) => new File([blob], "panImage.jpg", { type: "image/jpeg" }));
    formData.append("panImage", file);
    formData.append("fullName", data?.panName);
    formData.append("panNumber", data?.panNumber);
    formData.append("dateOfBirth", data?.dateOfBirth);

    try {
      const response = await axios.post(
        `${endPoint.SellerPanApi}/${SellerId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const SellerPanSlice = createSlice({
  name: "SellerPanData",
  initialState: {
    SellerPanData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SellerPan.fulfilled, (state, action) => {
        state.SellerPanData = action.payload;
      })
      .addCase(SellerPan.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default SellerPanSlice.reducer;
